import router from "../router";
export const getHeader = () => {
  const headers = {
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
  };
  var tokenData = localStorage.getItem("login_data");
  if (tokenData) {
    tokenData = JSON.parse(tokenData);
    headers["Authorization"] = "Bearer " + tokenData.token;
  }
  return headers;
};

export const handleResponse = (response, exportname, cb) => {
  response
    .then((res) => {
      if (exportname) {
        var a = document.createElement("a");
        // Determine MIME type based on file extension
        let mimeType = "application/octet-stream";
        if (exportname.toLowerCase().endsWith(".csv")) {
          mimeType = "text/csv;charset=utf-8;";
        } else if (exportname.toLowerCase().endsWith(".xlsx")) {
          mimeType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        }

        var blob = new Blob([res.data], {
          type: mimeType,
        });
        a.href = window.URL.createObjectURL(blob);
        a.download = exportname;
        var event = new MouseEvent("click");
        a.dispatchEvent(event);
        cb(null, res.data);
      } else if (res.data.status && res.data.status === "success") {
        cb(null, res.data);
      } else if (res.status && res.status === 201) {
        cb(null, res.data);
      } else {
        cb(new Error(res.data.message), res.data);
      }
    })
    .catch((err) => {
      handleError(err, cb);
    });
};

export const handleGoResponse = (response, exportname, cb) => {
  response
    .then((res) => {
      cb(null, res.data);
    })
    .catch((err) => {
      handleError(err, cb);
    });
};

const handleError = (err, cb) => {
  if (err.response && err.response.status === 401) {
    localStorage.removeItem("login_data");
    router.push("/login");
  } else if (err.response && err.response.status === 403) {
    router.push("/permission-denied");
    // } else if (err.response && err.response.status === 404) {
    // router.push("/page-not-found");
  } else if (err.response && err.response.status === 503) {
    router.push("/under-maintenance");
  } else if (err.response && err.response.data && err.response.data.error) {
    cb(new Error(err.response.data.error), err.response.data);
  } else if (err.response && err.response.data) {
    cb(new Error(err.response.data.message), err.response.data);
  }
};

export const getApiUrl = (serverId = null) => {
  serverId = serverId || getServerId();
  var configVar = "VUE_APP_API_BASE_URL_" + serverId;
  if (serverId && process.env[configVar]) {
    return process.env[configVar];
  }
  return process.env.VUE_APP_API_BASE_URL;
};

export const getGoApiUrl = (serverId = null, version = "v1") => {
  serverId = serverId || getServerId();
  var configVar = "VUE_APP_GO_API_BASE_URL_" + serverId;
  if (serverId && process.env[configVar]) {
    if (version == "v2") {
      return process.env[configVar].replace("/v1", "/v2");
    }
    return process.env[configVar];
  }
  if (version == "v2") {
    return process.env.VUE_APP_GO_API_BASE_URL.replace("/v1", "/v2");
  } else {
    return process.env.VUE_APP_GO_API_BASE_URL;
  }
};

export const getApiBaseUrl = (serverId = null) => {
  return getApiUrl(serverId).replace("/v2", "");
};

export const getServerId = () => {
  var serverId = null;
  var loginData = localStorage.getItem("login_data");
  if (loginData) {
    loginData = JSON.parse(loginData);
    serverId = loginData.server_id;
  }
  return serverId;
};
